import {Injectable} from '@angular/core';
import {Headers, Http} from '@angular/http';
import {environment} from '../../../../../../environments/environment';
import {Observable} from 'rxjs/Observable';
import {ApiEvsService} from '../../../../../common/services/ApiEvs.service';

@Injectable()
// tslint:disable-next-line:class-name
export class StatisticsAntiCounterfeitingService {
  headers: Headers;
  url = environment.qrcode_url;
  url_core_aps = environment.qrcode_url_aps;
  url_avs = environment.api_evs;

  constructor(
    private http: Http,
    private ApiEvsService: ApiEvsService
  ) {
    const token = localStorage.getItem('Access-Token');
    this.headers = new Headers({
      "Accept-Language": localStorage.getItem("lang") || "vi",
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });
  }

  // Tem có cảnh báo
  getOverviewAntiCounterfeiting(): Observable<any> {
    return this.http.get(`${this.url_core_aps}/statistic/anti-fake/overview`, {headers: this.headers}).map(res => {
      return res.json();
    });
  }

  getStampWarning(query?: any): Observable<any> {
    return this.http.get(`${this.url_core_aps}/statistic/anti-fake/stamp-warning`, {headers: this.headers, params: query}).map(res => {
      return res.json();
    });
  }

  public restoreStamp(body: any) {
    // return this.http.post('/qr_aps/restores', body);
    return this.http.post(`${this.url}/restores`, body, {headers: this.headers}).map((res) => {
      return res.json();
    }).catch((error: any) => {
      throw error.json();
    });
  }

  getListDetailStampWarning(query?: any, serial?: string) {
    return this.http.get(`${this.url_core_aps}/scan/active-history/${serial}`, {headers: this.headers, params: query}).map(res => {
      return res.json();
    });
  }

  // Cảnh báo chống giả theo khu vực
  getAntiCounterWarningArea(): Observable<any> {
    return this.http.get(`${this.url_core_aps}/statistic/anti-fake/stamp-warning/group-by-city`, {headers: this.headers,}).map(res => {
      return res.json();
    });
  }

  // ---------------
  /** Trạng thái quét theo sản phẩm **/
  getScanStampProduct(query?: any) {
    return this.http.get(`${this.url_core_aps}/statistic/product`, {headers: this.headers, params: query}).map(res => {
      return res.json();
    });
  }


  /** Trạng thái quét theo lô tem **/
  getDataScanStamp(query?: any) {
    return this.http.get(`${this.url_core_aps}/statistic/batch`, {headers: this.headers, params: query}).map(res => {
      return res.json();
    });
  }


  getDashboardScanLocation(data: any) {
    return this.http.get(`${this.url_avs}/statistic/batch`, {headers: this.headers, params: data}).map(res => {
      return res.json();
    });
    // return this.http.get(`${this.url_core_aps}/dashboard/scan_location`, data);
  }

  getDashboardScans(data: any) {
    // return this.http.get(`${this.url_avs}/dashboard/scan_status`, {headers: this.headers, params: data}).map(res => {
    //   return res.json();
    // });
    return this.ApiEvsService.get('/dashboard/scan_status', data);
  }

  getDashboardScanNew(data: any) {
    return this.http.get(`${this.url_core_aps}/statistic/chart/scan-active-of-the-day`, {headers: this.headers, params: data}).map(res => {
      return res.json();
    });
    // return this.get("/dashboard/scan_status", data);
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/statistics-anti-counterfeiting/services/statistics-anti-counterfeiting.service.ts